const DEFAULT_HAIRCOLOR_CONTINUE_URL = "/haircolor-3month-29";
const RECOMMEND_HAIRCOLOR_CONTINUE_URL = "/haircolor-recomend-3month-29";
const RECOMMEND_CAMPAIGN_TOKENS = ["HairColor_Recommendation", "HairColor_TryOn_Changer"];

export const getHaircolorV2ContinueUrl = (search = "") => {
  const params = new URLSearchParams(search);
  const campaignValues = params.getAll("utm_campaign");

  if (
    campaignValues.some((campaign) =>
      RECOMMEND_CAMPAIGN_TOKENS.some((token) => campaign.includes(token))
    )
  ) {
    return RECOMMEND_HAIRCOLOR_CONTINUE_URL;
  }

  return DEFAULT_HAIRCOLOR_CONTINUE_URL;
};

export const buildHaircolorUserPhotoContinueUrl = ({
  search = "",
  queuedJobId = "",
} = {}) => {
  const params = new URLSearchParams(String(search || "").replace(/^\?/, ""));
  const hasUserImage = Boolean((params.get("img") || params.get("image") || "").trim());
  const targetPaywallUrl = getHaircolorV2ContinueUrl(search);

  params.delete("utm_ab");

  if (queuedJobId && hasUserImage) {
    params.set("facemesh_job_id", queuedJobId);
  } else {
    params.delete("facemesh_job_id");
  }

  const queryString = params.toString();
  return queryString ? `${targetPaywallUrl}?${queryString}` : targetPaywallUrl;
};
